import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { dashLogin, getPermissions } from "../Api/authentication";
import { appLogout, useAppDispatch } from "../app/store";
import { AuthContext } from "../context/AuthProvider";
import { setAuthtenticated, setUser as setReduxUser, setToken } from "../features/Dashboard/Slices/userSlice";
import { validateToken } from "../features/Dashboard/AsyncThunks/estadoGeneral/validateToken";
import { isRejected } from "@reduxjs/toolkit";

export const useAuth = () => {
  const context = useContext(AuthContext);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  const { user, setUser, permissions, setPermissions, hasPermission, isLoading } = context;

  const saveToken = (token: string) => {
    dispatch(setToken(token));
    localStorage.setItem("token", token);
  }

  const login = async (email: string) => {
    try {
      const response = await dashLogin(email);
      if (response.token) {
        const authenticatedResult = await dispatch(validateToken(response.token));
        if (isRejected(authenticatedResult)) {
          throw new Error("Token is invalid");
        }
        const userPermissions = response.info?.permisos || {};
        saveToken(response.token);
        dispatch(setAuthtenticated(true));
        if (response.info) {
          dispatch(setReduxUser(response.info));
        }
  
        //localStorage.setItem("email", email); 
        setUser(response);
        setPermissions(userPermissions);
        navigate("/");
      } else {
        console.log("Error: No token received");
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const logout = () => {
    dispatch(setToken(null));
    setUser(null);
    setPermissions({});
    localStorage.clear();
    dispatch(setAuthtenticated(false));
    dispatch(appLogout());
    navigate("/login");
  };

  const getRolePermissions = async () => {
    const response = await getPermissions();
    if (response.permisos) {
      setPermissions(response.permisos);
    }
  };

  return {
    user,
    permissions,
    hasPermission,
    isLoading,
    login,
    logout,
    isAuthenticated: !!user?.token,
    getRolePermissions,
  };
};

export default useAuth;